import { InputTextType } from '../Enum/InputTextType';
import InputTextControl from './InputTextControl';
import ValidationMessages from '../Data/ValidationMessages';
export default class InputEmailControl extends InputTextControl {
    constructor(field) {
        super(field);
        this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.type = InputTextType.email;
    }
    validate(clearValidationMessages = true) {
        this.clearValidationMessages();
        this.field.isCustomValid = true;
        if (!this.emailRegex.test(this.getRawValue())) {
            this.addValidationMessage(ValidationMessages.email());
            this.field.isCustomValid = false;
        }
        return super.validate(false);
    }
}
